var _defs, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack621({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.85,11.78V3.91H6.44v3.5l3.21-3.5h2.14L8.82,7,12,11.78H9.89L7.73,8.09,6.44,9.4v2.38Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack621);
export default __webpack_public_path__ + "static/media/Symbolpack_6_21.4c819080856062702c46dfb361d147e0.svg";
export { ForwardRef as ReactComponent };